import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';

import './FgVideos.scss';
import { useDispatch, useSelector } from 'react-redux';
import { MediaType, Media } from '../../../models/mediaClass';

import { MediaService} from '../../../services/media-service';
import { container } from 'tsyringe';
import { getOffset, sleep, useSharedState } from '../../../utils/helpers';

import { SELECT_MEDIA, UNSELECT_MEDIA } from '../../../redux/medias/mediaReducer';

import { ApiService } from '../../../services/api-service';

import * as R from 'ramda';

import Lottie from 'react-lottie-player'
import lottieJson from '../../../assets/lottie/loading_spinner.json';
import { ActionType, GroupType } from '../../../models/actionClass';
import { WebRTCsdkService } from '../../../services/webrtcsdk-service';
import { CmsManagementService } from '../../../services/cms-management-service';
import { PTApiService } from '../../../services/ptapi-service';
import { MeetingStore } from '../../../models/meetingClass';
import { SoundKey, SoundService } from '../../../services/sound-service';

import { ReactComponent as MenuSvg} from '../../../assets/icons/icon-three-dots.svg';

import useOnClickOutside from '../../hooks/useOnClickOutside';
import ContextualMenu from './ContextualMenu';
import InlineEdit from '../../utils/InlineEdit';
import NewLabel from '../../newLabel/NewLabel';
import UploadVideoCms from './uploadVideoCMS';
import StopSharingDialog from '../../livePreview/stopSharingDialog';
import { HideImage } from '@mui/icons-material';
import { PTSocketService } from '../../../services/ptsocket.service';
import { videoStatusEnum } from '../../livePreview/showLiveForeground';


export interface FgVideoProps {
  fgv: Media;
}

const FgVideo = (props: FgVideoProps) => {

  const {fgv} = props;
  const contextualMenuRef = useRef(undefined);

  const [apiService] = useState(container.resolve(ApiService));
  const [mediaService] = useState(container.resolve(MediaService));
  const [ptApiService] = useState(container.resolve(PTApiService));
  const [ptSocketService] = useState(container.resolve(PTSocketService));
  const [webRTCsdkService] = useState(container.resolve(WebRTCsdkService));
  const [cmsManagementService] = useState(container.resolve(CmsManagementService));
  const [soundService] = useState(container.resolve(SoundService));

  const { fgVideo, fgImage, producers } = useSelector((state: any) => ({
    fgVideo: state.media.fgVideo,
    fgImage: state.media.fgImage,
    producers: state.producers,
  }));
  const dispatch = useDispatch();

  const [isMenuOpened, setMenuOpened] = useState(false);
  const [isRenaming, setIsRenaming] = useState(false);

  const [showStopSharing, setShowStopSharing] = useState(null);

  const [sharedVideoState, setSharedVideoState] = useSharedState(ptSocketService.sharedVideo$);


  const meetingStore: MeetingStore = useSelector((state: any) => state.meetingStore);

  useOnClickOutside(contextualMenuRef, () => {
    setMenuOpened(false);
  });

  // const [videoSharingAction] = useSharedState(webRTCsdkService.videoAction$);

  const onSelect = async (video, force = false) => {

    const myself = producers && producers.length>0 ? producers[0].participantGuid :  '';

    if (!force && meetingStore.receivingContent && (meetingStore.presenterGuid !== myself || meetingStore.currentVideoId === 'screenshare')) {
      setShowStopSharing(video);
      return;
    }


    let delay = 0;
    if (IsSelected(video.id)) {
      // already selected => do nothing
      return;
    }

    if (fgVideo && fgVideo.id !== video.id) {
      // unselect current video
      onHide(fgVideo);
      delay = 300;

      // give time to continue
      await sleep(1000);
    }

    //  unselect any selected image
    if (fgImage) {
      apiService.updateReason = {group: MediaType.FG_IMAGE, action: ActionType.UNSELECT, id: fgImage.id};
      dispatch({type: UNSELECT_MEDIA, payload: MediaType.FG_IMAGE});
      mediaService.unselect(MediaType.FG_IMAGE, null);
      apiService.saveChannel('FgVideo remove image');
      delay = 600;
    }

    mediaService.select(MediaType.FG_VIDEO, video.id);
    dispatch({type: SELECT_MEDIA, payload: R.clone(video)});

    apiService.updateReason = {group: MediaType.FG_VIDEO, action: ActionType.SELECT, id: video.id};

    // ptApiService.shareVideoAction(video.id, 'start', 0);
    setSharedVideoState({contentId: video.id, state: videoStatusEnum.PLAYING, seek: 0});

    // TODO do we keep autoplay ?
    // setTimeout(() => {
    //   ptApiService.shareVideoAction(video.id, 'play', 0);
    // }, 1000);

    setTimeout(() => {
      apiService.saveChannel('FgVideos');
    }, delay);

  }
  const onHide = (video) => {
    if (!IsSelected(video.id)) {
      return;
    }

    dispatch({type: UNSELECT_MEDIA, payload: MediaType.FG_VIDEO})
    mediaService.unselect(MediaType.FG_VIDEO, video.id);

    apiService.updateReason = {group: MediaType.FG_VIDEO, action: ActionType.UNSELECT, id: video.id};

    // ptApiService.shareVideoAction(video.id, 'stop', 0);
    setSharedVideoState({contentId: video.id, state: videoStatusEnum.CLOSED, seek: 0});
    webRTCsdkService.releasePresentationToken();

    apiService.saveChannel('FgVideos');
  }

  const IsSelected = (id) => {
    return fgVideo && fgVideo.id === id;
  }


  const focusRename = () => {
    setMenuOpened(false);
    setIsRenaming(true);
  }

  const renameFgVideo = (newName) => {
    setIsRenaming(false);
    console.log('new logo name:' , newName);

    setTimeout(() => {
      fgv.name = newName;
      fgv.isNew = true;
      mediaService.save(fgv.type, fgv);
      apiService.updateReason = {group: fgv.type, action: ActionType.RENAME, value: fgv};
      apiService.saveChannel('fgv');
    }, 100);
  }

  const deleteFgVideo = () => {

    // hide this logo from selected list
    onHide(fgv);
    setMenuOpened(false);

    mediaService.remove(fgv.type, fgv.id, fgv.origin);

    apiService.updateReason = {group: GroupType.FG_VIDEO, action: ActionType.REMOVE, id: fgv.id};
    apiService.saveChannel('fgVideo');

    soundService.playSoundStart(SoundKey.Trash)
  }

  const runMenuClose = () => {
    // console.log('scroll runMenuClose');
    setMenuOpened(false);
  }

  const handleStopSharingDialog = (value) => {
    if (value === 'cancel') {
      console.log('Dont start video sharing');
    } else {
      console.log('Start video sharing');
      // stop current shared video
      if (meetingStore.currentVideoId != '' && meetingStore.currentVideoId !== 'screenshare') {
        //ptApiService.shareVideoAction(meetingStore.currentVideoId, 'stop', 0);
        setSharedVideoState({contentId: meetingStore.currentVideoId, state: videoStatusEnum.CLOSED, seek: 0});

      }
      // save video to play before reset
      const nextVideo = showStopSharing;
      onSelect(nextVideo, true);

      // as video is stopped by others moderator (from event UI) when they exits from screen or video sharing -> start again the video
      setTimeout(() => {
        onSelect(nextVideo, true);
      }, 1000);
    }
    setShowStopSharing(null);
  }



  // Add event listeners
  useLayoutEffect(() => {
    if (isMenuOpened) {
      // console.log('set scroll listener');
      window.addEventListener("scroll", runMenuClose, true);
    }

    // Remove event listeners on cleanup
    return () => {
      // console.log('remove scroll listener');
      window.removeEventListener("scroll", runMenuClose, true);
    };
  }, [isMenuOpened]);

  let top, left = 0;
  if (isMenuOpened) {

    const videoDiv = document.getElementById('menufgvid-' + fgv.id);
    if (videoDiv) {
      const position = getOffset(videoDiv);
      left = position.left - 64;
      top = position.top - 70;
    }
  }

  // useEffect(() => {
  //   if (videoSharingAction === 'stop') {
  //     onHide(video.id);
  //   }
  // }, [videoSharingAction])

  return (
    <>
      <div className="container">
        <div className="img" style={{ backgroundImage: `url(${fgv.source})`}} onClick={() => IsSelected(fgv.id) ? onHide(fgv) : onSelect(fgv)}></div>
        { IsSelected(fgv.id) ?
        <>
        <div className="action selected"></div>
        </>
        :
        <div className="action unselected"></div>
        }
        <div className="tick-video"></div>
        <div className="name">
        <InlineEdit
          height={18}
          key={fgv.name}
          text={fgv.name}
          placeHolder="&middot;&middot;&middot;"
          focused={isRenaming}
          onSetText={(text) => renameFgVideo(text)}
          onDiscard={() => setIsRenaming(false)} />
        </div>
      </div>
      <div className="button-more"  id={'menufgvid-' + fgv.id} ref={contextualMenuRef}>
        <MenuSvg className="menu-icon" onClick={() => setMenuOpened(!isMenuOpened)}/>
        {isMenuOpened &&
          <ContextualMenu onRename={focusRename} onDelete={deleteFgVideo} style={{top, left}}></ContextualMenu>
        }
      </div>
      { fgv.isNew &&
        <NewLabel type={'label-video'}></NewLabel>
      }
      <StopSharingDialog open={showStopSharing} onClose={(e) => handleStopSharingDialog(e)} remoteParticipantName={meetingStore.presenterName}></StopSharingDialog>

    </>
  )
}


const FgVideos = () => {

  const [mediaService] = useState(container.resolve(MediaService));
  const [apiService] = useState(container.resolve(ApiService));

  const [videos] = useSharedState(mediaService.fgVideos$);
  const [videoLayer] = useSharedState(apiService.fgVideo$);

  const fgImage = useSelector((state: any) => state.media.fgImage);
  const fgVideo = useSelector((state: any) => state.media.fgVideo);
  const dispatch = useDispatch();

  const [selectedFile, setSelectedFile] = useState(null);
	const [isFilePicked, setIsFilePicked] = useState(false);
  const [isFileFailed, setIsFileFailed] = useState(false);
  const [isFileError, setIsFileError] = useState(false);

  const [uploadPercentage, setUploadPercentage] = useState('');


  // assets
  const [cmsService] = useState(container.resolve(CmsManagementService));
  const [uploadVideoKey, setUploadVideoKey] = useSharedState(cmsService.uploadVideoKey$);


  const [showLess, setShowLess] = useState(true);
  const maxLessLength = 6;

  const clearAndUpload = () => {
    setIsFilePicked(false);
    setIsFileFailed(false);
    setIsFileError(false);
    setSelectedFile(null);

    // give time for ADD btn to be redisplayed
    setTimeout(() => {
      const fileAdd = document.getElementById('file-upload-VIDEO');
      if (fileAdd) {
        fileAdd.click();
      }
    }, 100);
  }

  const uploadStarted = (file) => {
    setIsFileFailed(false);
    setIsFileError(false);
    setSelectedFile(file);
    setIsFilePicked(true);
  }

  const uploadProgress = (percent) => {
    setUploadPercentage(percent == 0 ? '' : Math.floor(percent) + '%');
  }

  const uploadCompleted = () => {
    mediaService.refresh(MediaType.FG_IMAGE);
    setSelectedFile(null);
    setUploadPercentage('100%');
    // setIsFilePicked(false);
  }

  const uploadFailed = () => {
    setIsFileFailed(true);
  }

  const fileError = () => {
    setIsFilePicked(true);
    setIsFileError(true);
    setIsFileFailed(true);
  }


  useEffect(() => {
    if (videoLayer) {
      // search for FgImages and update select flag
      const video = mediaService.select(videoLayer.type, videoLayer.sourceId);
      if (video) {
        dispatch({type: SELECT_MEDIA, payload: R.clone(video)});
        // unselect images
        if (fgImage) {
          dispatch({type: UNSELECT_MEDIA, payload: MediaType.FG_IMAGE});
          mediaService.unselect(MediaType.FG_IMAGE, null);
        }
      } else {
        if (fgVideo) {
          dispatch({type: UNSELECT_MEDIA, payload: MediaType.FG_VIDEO});
          mediaService.unselect(MediaType.FG_VIDEO, null);
        }
      }
    } else {
      if (fgVideo) {
        dispatch({type: UNSELECT_MEDIA, payload: MediaType.FG_VIDEO});
        mediaService.unselect(MediaType.FG_VIDEO, null);
      }
    }
  }, [videoLayer]);

  let lessFiltered = showLess ? R.clone(videos).slice(0,maxLessLength) : R.clone(videos);

  useEffect(() => {

    if (uploadVideoKey) {
      // check if videos now contains uploadAssetKey
      const media = videos.find(fgv => fgv.id === uploadVideoKey);
      if (media) {
        // remove file upload animation
        setIsFilePicked(false);
        setUploadVideoKey(null);
      }
    }

    lessFiltered = showLess ? R.clone(videos).slice(0,maxLessLength) : R.clone(videos);
    console.log('videos updated', videos, lessFiltered);
  }, [videos, showLess]);



  return (
    <div className='FgVideos'>
      <UploadVideoCms accept={'.mp4, .mov, .webm, .ogv'} uploadStarted={uploadStarted} uploadProgress={uploadProgress} uploadCompleted={uploadCompleted} uploadFailed={uploadFailed} fileError={fileError}></UploadVideoCms>

      <ul className="videos">
        {isFilePicked &&
          <li key="loading" className="video">
          <div className="container">
            {!isFileFailed ?
            <>
              <div className="img" style={{background: "#f0f0f0"}}>
                <Lottie loop animationData={lottieJson} play style={{ width: "100%", height: "100%"}} />
              </div>
                <div className="percentage">{uploadPercentage}</div>
                <div className="name">{selectedFile?.name}</div>
            </>
            :
             isFileError ?
              <>
              <div className="img file-error" style={{background: "rgba(255, 51, 121, 0.05)", border: "dashed 1px #e01e5a"}} onClick={() => clearAndUpload()}>
              </div>
              </>
              :
              <>
                <div className="img failed-upload" style={{background: "rgba(255, 51, 121, 0.05)", border: "dashed 1px #e01e5a"}} onClick={() => clearAndUpload()}>
                </div>
                <div className="name failed">Failed - click to retry!</div>
              </>

            }
          </div>
        </li>
      }
      {
          lessFiltered.map( vid => {
            return (<li key={vid.id} className="video">
              <FgVideo fgv={vid}></FgVideo>
            </li>)
          })
      }
      </ul>
      { isFileError &&
        <div className="explain-error">
          Supported formats: MP4, OGV, MOV, WEBM.<br/>
          Max file size: 300MB
        </div>
      }

      { videos.length > maxLessLength ?
          (showLess ?
            <div className="show-action show-less" onClick={() => setShowLess(false)}>Show More</div>
            :
            <div className="show-action show-more" onClick={() => setShowLess(true)}>Show Less</div>
          )
        : <></>
      }
      { videos.length === 0 &&
        <div className="empty">No video available! Press &ldquo;+&rdquo; to add one.</div>
      }

    </div>
  );

}

export default FgVideos;